{
  "role": "JDF REVIEWER",
  "emailID": "***********",
  "name":"JDF Reviewer",
  "recipientId":"110",
  "routingOrder": 6,
  "signingOption": "Sign by email"
}
